import { useLazyQuery, useQuery } from '@apollo/client';
import { useRef } from 'react';
import { useDispatch } from 'react-redux';
import {
  setExecutionExists,
  setExecutionUserOwnsTest,
  setExecutionStatus,
  setExecutionConsecutiveFails,
} from '../../../App/Slices/TestResults';
import {
  ATT_ENV,
  CANCELLED,
  FINISHED,
  REGIONS_DICTIONARY,
} from '../../../Constants/constants';

export const useTestResultsQueries = ({
  id,
  user,
  queryGetDuration,
  queryGetRegionAndName,
  queryGetUrlTestsIds,
  queryGetFailedExecutions,
  getDurationQueryName,
  getNameAndRegionQueryName,
  getTestResultsQueryName,
  onCancelRedirectUrl,
  queryFinished,
  start,
  urlsLength,
  maxDuration,
  pollInterval,
  setStopCount,
  name,
  region,
}) => {
  const dispatch = useDispatch();
  const pendingUrlTests = useRef([]);

  //Query: Get Duration
  useQuery(queryGetDuration, {
    variables: { id },
    notifyOnNetworkStatusChange: true,
    onCompleted: (data) => {
      queryFinished.current = true;
      if (data[getDurationQueryName] === null) {
        dispatch(setExecutionExists(false));
        return;
      }
      dispatch(
        setExecutionUserOwnsTest(data[getDurationQueryName].userId === user._id)
      );
      urlsLength.current = data[getDurationQueryName].total;
      start.current = new Date(data[getDurationQueryName].start);
      const finalStatus = data[getDurationQueryName].status;
      dispatch(setExecutionStatus(finalStatus));

      if (finalStatus === FINISHED || finalStatus === CANCELLED) {
        setStopCount(true);
        maxDuration.current = data[getDurationQueryName].duration;
        pollInterval.current = 5000;
      }
    },
    onError: () => {
      dispatch(setExecutionExists(false));
      queryFinished.current = true;
    },
  });

  //Query: Get URL Test Ids
  useQuery(queryGetUrlTestsIds, {
    variables: { executionId: id, limit: 1000 },
    notifyOnNetworkStatusChange: true,
    onCompleted: (data) => {
      pendingUrlTests.current = data[getTestResultsQueryName];
      if (pendingUrlTests.current.length === 0) {
        window.flash('There are no results related to execution', 'info');
        setTimeout(() => (window.location = onCancelRedirectUrl), 4000);
      }
    },
    onError: () => {},
  });

  //Lazy query: Consecutive failed count
  const [getConsecutiveFailedCount] = useLazyQuery(queryGetFailedExecutions, {
    onCompleted: (data) => {
      dispatch(
        setExecutionConsecutiveFails(
          data.testExecutionGetConsecutiveFailedCount.count
        )
      );
    },
    onError: () => {},
  });

  //Query: Get RegionAndName
  useQuery(queryGetRegionAndName, {
    variables: { id },
    notifyOnNetworkStatusChange: true,
    onCompleted: (data) => {
      name.current = data[getNameAndRegionQueryName].name ?? null;
      region.current =
        REGIONS_DICTIONARY[data[getNameAndRegionQueryName].region] ?? null;

      if (name.current.length - 25 > 0) {
        getConsecutiveFailedCount({
          variables: {
            filters: {
              attEnv: ATT_ENV,
              nameRegEx: name.current.slice(0, name.current.lenght - 25),
              nameChild: name.current,
            },
          },
        });
      }
    },
    onError: () => {},
  });

  return { pendingUrlTests };
};
